import { ComboBox, Item } from '../ComboBox';

import {
  PrimaryListing,
  type Props as PrimaryListingProps,
} from './PrimaryListing';
import {
  SecondaryListing,
  type Props as SecondaryListingProps,
} from './SecondaryListing';

export type Option = PrimaryListingProps | SecondaryListingProps;

interface Props {
  options: Option[];
  onSelect?: (id: string) => void;
  inputValue?: string;
  onInputChange?: (value: string) => void;
  status: 'pending' | 'success' | 'error';
}

export const TickerSearch = ({
  options,
  onSelect,
  inputValue,
  onInputChange,
  status,
}: Props) => {
  return (
    <ComboBox
      label="Select a ticker"
      placeholder="Search for a ticker"
      items={options}
      inputValue={inputValue}
      onInputChange={onInputChange}
      onSelectionChange={(id) => onSelect?.(String(id))}
      status={status}
    >
      {(item) => (
        <Item textValue={item.label} key={item.id}>
          {item.type === 'primary' ? (
            <PrimaryListing {...item} />
          ) : (
            <SecondaryListing {...item} />
          )}
        </Item>
      )}
    </ComboBox>
  );
};
